import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'

import '@/styles/index.scss'
import '@/styles/uVant.scss'

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

import qs from 'qs'
Vue.prototype.qs = qs

import VueParticles from 'vue-particles'
Vue.use(VueParticles)

import moment from 'moment'
Vue.prototype.moment = moment

import vueSeamlessScroll from 'vue-seamless-scroll'
Vue.use(vueSeamlessScroll)

import ipInf from './utils/ipconfig'
Vue.prototype.ip = ipInf.ip

import VueLoopScroll from 'vueloopscroll'
import 'vueloopscroll/lib/vueloopscroll.css'
Vue.use(VueLoopScroll)

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

import axios from 'axios'
Vue.prototype.$axios = axios

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import animated from 'animate.css'
Vue.use(animated)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
